<template>
  <v-menu v-if="$auth.watch.authenticated" bottom left offset-y>
    <v-btn
      color="white"
      flat
      round
      icon
      slot="activator"
    >
      <v-icon>more_vert</v-icon>
    </v-btn>
    <v-list>
      <template v-for="item in menuItems">
        <v-list-tile
          v-bind:key="item.name"
          @click="$router.push({name: item.name, params: {teamId: $teamService.currentTeamId}})"
        >
          <v-list-tile-title>{{ item.title }}</v-list-tile-title>
        </v-list-tile>
      </template>
    </v-list>
  </v-menu>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'app',
  computed: {
    menuItems () {
      var items = this.$router.options.routes.filter(it =>
        it.meta &&
        it.meta.inMenu &&
        (
          it.meta.auth &&
          this.$auth.watch.authenticated &&
          it.name !== 'Login'
        )
      ).filter(it => {
        if (!this.$teamService.currentTeamId && it.props === true) {
          return false
        }
        return true
      }).filter(it => {
        if (!it.meta.roles) return true;
        const user = Vue.$auth.user();
        const roles = user.roles;
        const currentTeamId = this.$teamService.currentTeamId;
        const roleInCurrentTeam = user.roles[currentTeamId];
        const allowUser = it.meta.roles.includes(roleInCurrentTeam);
        return allowUser;
      });
      var logoutItem = false;
      if(items[items.length-1].name === 'Logout') {
        logoutItem = items.pop();
      }
      if(Vue.$auth.user().teams.length > 1) {
        items.push({
          name: 'Home',
          title: 'Switch Team',
          path: '/',
          component: 'Home',
          meta: {
            inMenu: true
          }
        })
      }
      if(logoutItem) {
        items.push(logoutItem)
      }
      return items;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/MainMenu.vue